const dayjs = require('dayjs')
const isBetween = require('dayjs/plugin/isBetween')
const isSameOrBefore = require('dayjs/plugin/isSameOrBefore')
dayjs.extend(isBetween)
dayjs.extend(isSameOrBefore)

const daysToOpening = 28
const daysAlreadyOpened = 90

const checkMarketOpening = (today, market) => {
  const openingDay = dayjs(new Date(market.openingDay))
  const twoWeeksBeforeOpening = openingDay.subtract(daysToOpening, 'day')
  const threeMonthsAfterOpening = today.subtract(daysAlreadyOpened, 'day')

  const aboutToOpen = today.isBetween(
    twoWeeksBeforeOpening,
    openingDay,
    null,
    '[)'
  )
  const afterOpeningDate = openingDay.isSameOrBefore(today)

  const alreadyOpened = openingDay.isBetween(
    threeMonthsAfterOpening,
    today,
    null
  )

  return { aboutToOpen, afterOpeningDate, alreadyOpened }
}

module.exports = checkMarketOpening
